import React from 'react';

type AffixProps = {
  top: number;
  offset?: number;
  className?: string;
};

const Affix: React.FC<AffixProps> = props => {
  const element = React.createRef<HTMLDivElement>();
  let old_styles = {
    position: '',
    top: '',
    width: '',
  };

  React.useEffect(() => {
    if (typeof window.scrollY === 'undefined') {
      // don't work in IE
      return;
    }

    function adjustHeight() {
      element.current.style.height = window.innerHeight - Math.max(element.current.getBoundingClientRect().y, 0) + 'px';
      if (element.current.getBoundingClientRect().y < 0) {
        element.current.style.height = element.current.getBoundingClientRect().height + element.current.getBoundingClientRect().y + 'px';
      }
    }

    adjustHeight();

    window.addEventListener('scroll', adjustHeight);
    window.addEventListener('resize', adjustHeight);
    return () => {
      window.removeEventListener('scroll', adjustHeight);
      window.removeEventListener('resize', adjustHeight);
    };
  });

  return (
    <div ref={element} style={{ position: 'sticky', top: '0px', zIndex: 1, overflow: 'auto' }} className={props.className}>
      {props.children}
    </div>
  );
};

Affix.defaultProps = {
  offset: 0,
};

export default Affix;
